import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function FilterIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0002 2H1L7.98838 9.86341C8.63907 10.5956 8.9985 11.5411 8.9985 12.5206V22L15.0011 18.0564V12.5207C15.0011 11.5411 15.3606 10.5956 16.0113 9.86338L23.0002 2ZM18.5469 4H5.45313L9.48332 8.53482C10.4594 9.63307 10.9985 11.0513 10.9985 12.5206V18.293L13.0011 16.9774V12.5207C13.0011 11.0513 13.5403 9.63301 14.5164 8.53473L18.5469 4Z",
    fill: "currentColor"
  }));
}